<template>
    <div>
        <CRow>
        </CRow>

        <CCardBody>
            <div id="tree-table"></div>

        </CCardBody>


    </div>

</template>

<script>
    import axios from "axios";

    var items = [];


    export default {
        name: 'Reports',
        data() {
            return {

                json_data: [],

            }
        }, mounted() {
            this.get_categories();
        }, watch: {},
        methods: {


            get_categories() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));
                axios.post('/api/admin/cat_product_report', formData, {}).then(function (response) {
                    var data = [];
                    // response.data.categories.forEach(function (val) {
                    //     val.products = [];
                    // })

                    var categories = response.data.categories.filter(x => x.parent_category == null);

                    categories.forEach(function (val) {
                        val._children = self.get_child_cat(val, response.data.categories, response.data.products)
                    })
                    self.json_data = categories;
                    console.log("data json is ", self.json_data)
                    self.show_table();

                    // self.items = content_cats

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_child_cat(item, list, products) {
                var self = this;
                if (list.filter(x => x.parent_category != null && parseInt(x.parent_category.parent) == item.id).length > 0) {
                    var data = []
                    list.filter(x => x.parent_category != null && parseInt(x.parent_category.parent) == item.id).forEach(function (val) {
                        val._children = self.get_child_cat(val, list, products);
                        data.push(val);

                    });
                    return data;
                } else {
                    var pro_list = [];
                    products.forEach(function (pro) {
                        pro.categories.forEach(function (pro_cat) {
                            if (item.id == pro_cat.cat_id) {
                                pro_list.push(pro);
                            }
                        })
                    })
                    if (pro_list.length > 0) {
                        return pro_list;
                    } else {
                        return null;

                    }
                }
            },
            show_table() {
var self = this;
                var table = new Tabulator("#tree-table", {

                    height: "500px",
                    data: this.json_data,
                    dataTree: true,
                    dataTreeStartExpanded: false,
                    columns: [
                        {title: "نام دسته", field: "cat_title", width: '20%', responsive: 0}, //never hide this column
                        {
                            title: "تعداد کالا", field: "_children", width: '10%',
                            formatter: function (cell, formatterParams) {
                                var value = cell.getValue();
                                if (value != null) {
                                    return self.get_product_cunt(value);
                                }
                            }
                        },{
                            title: "تصویر کالا", field: "gallery", width: '10%',
                            formatter: function (cell, formatterParams) {
                                var value = cell.getValue();
                                if (value != null) {
                                    return '<img src="' + value[0].product_image + '" width="100px" height="100px" />';
                                }
                            }
                        },
                        {title: "نام کالا", field: "title", width: '50%'},
                        {
                            title: "قیمت",
                            field: "price",
                            hozAlign: "right",
                            width: '30%',
                            formatter: function (cell, formatterParams) {
                                var value = cell.getValue();
                                if (value != null) {

                                    return value.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                            }
                        },

                        // {title: "نوع حساب", field: "AccType", width: '10%', responsive: 0}, //never this column first,for hide responsive 2
                        // {title: "ماهیت حساب", field: "AccNature", width: '10%'},
                    ],
                    // rowFormatter:function(row){
                    //     if(row.getData().AccBalance < 0){
                    //         console.log(row.getData(),row.getElement())
                    //         row.setData().AccBalance = "("+row.getData().AccBalance+")"; //mark rows with age greater than or equal to 18 as successful;
                    //         // row.getElement().classList.add("success"); //mark rows with age greater than or equal to 18 as successful;
                    //     }
                    // },
                });
            },
            get_product_cunt(children){
                var count = 0;
                var self = this;
                children.forEach(function (val) {
                    if(val.view_count!=null){
                        count++;
                    }else{
                        if(val._children!=null){
                            count = count + self.get_product_cunt(val._children)
                        }
                    }
                })
                return count;
            }

        }
    }


</script>
<style>
    .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-sorter {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        position: absolute;
        top: 0;
        bottom: 0;
        right: auto;
        left: 4px;
    }
</style>
